import { useEffect, useMemo, useRef } from 'react';

import { useSession } from 'modules/accounts/hooks';

export function usePendingCryptoOrderBanner() {
  const skip = useRef(false);
  const { session } = useSession({ pollingInterval: 60_000, skip: skip.current });

  const isVisible = useMemo(() => {
    if (!session) return false;

    return session.pendingCryptoOrders > 0;
  }, [session]);

  useEffect(() => {
    if (!session) return;

    skip.current = session.pendingCryptoOrders === 0;
  }, [session]);

  return useMemo(() => ({ isVisible }), [isVisible]);
}
